<template>
  <table width="100%">
    <thead>
      <tr>
        <td>Month</td>
        <td>FO (t)</td>
        <td>
          CO
          <sub>2</sub> (t)
        </td>
        <td>%</td>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, i) in results_.focMonthly"
        :style="month === i ? 'font-weight:bold' : ''"
      >
        <td @click="month = i">{{months[i]}}</td>
        <td
          v-b-popover.hover.right.html="'<strong>FOC (t)</strong><br />Baseline: '+row.BL.toFixed(1)+'<br/>With FRS: '+row.FRS.toFixed(1)"
        >{{((row.BL-row.FRS)).toFixed(1)}}</td>
        <td>{{((row.BL-row.FRS)*3.151).toFixed(1)}}</td>
        <td>{{(100*(1-row.FRS/row.BL)).toFixed(1)}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr style="font-size:1.3rem">
        <td>Yearly Avg</td>
        <td
          v-b-popover.hover.right.html="'<strong>FOC (t)</strong><br />Baseline: '+results.focYearly.BL.toFixed(1)+'<br/>With FRS: '+results.focYearly.FRS.toFixed(1)"
        >{{((results.focYearly.BL-results.focYearly.FRS)).toFixed(1)}}</td>
        <td>{{((results.focYearly.BL-results.focYearly.FRS)*3.151).toFixed(1)}}</td>
        <td>{{(100*(1-results.focYearly.FRS/results.focYearly.BL)).toFixed(1)}} %</td>

      </tr>
    </tfoot>
  </table>
</template>

<script>

export default {
  name: "MontlyPerformanceTable",
  props: {
      results : Object,
      month : Number
  },
  data: function() {
      return {
          months: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
            ],
            results_ : JSON.parse(JSON.stringify(this.results))
      }
  },
  // computed: {
  //   results_: {
  //       get () {return this.results},
  //       // set (v) { this.results_ = v }       
  //   }
  // },
  watch: {
    results: {
      handler: function(val) {
        this.results_ = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  }

};
</script>

<style scoped>
thead,
tfoot {
  font-weight: bold;
  /* font-size: 1.2rem; */
}
thead {
  border-bottom: 1px solid black;
}
tfoot {
  border-top: 1px solid black;
}
</style>
